const storage = {};
function setStorageItem(key, data) {
    try {
        window.localStorage.setItem(key, data);
    }
    catch (err) {
        storage[key] = data;
    }
}
function getStorageItem(key) {
    try {
        const text = window.localStorage.getItem(key);
        return JSON.parse(text);
    }
    catch (err) {
        return storage[key];
    }
}

export { getStorageItem, setStorageItem };
//# sourceMappingURL=storage.js.map
